import { useLocation } from 'react-router-dom';
import { categories, articles, faqs, aboutInfo } from '@/mocks/yihao';

export function OrganizationSchema() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '壹号娱乐',
    url: 'https://bukedg.cn',
    description: '壹号娱乐是您值得信赖的综合娱乐平台，提供多元化娱乐内容与极致体验服务。',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
      hoursAvailable: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '00:00',
        closes: '23:59',
      },
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

export function WebSiteSchema() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '壹号娱乐',
    url: 'https://bukedg.cn',
    description: '壹号娱乐是您值得信赖的综合娱乐平台。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://bukedg.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

export function WebPageSchema({ title, description, url }: { title: string; description: string; url: string }) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: url,
    isPartOf: {
      '@type': 'WebSite',
      name: '壹号娱乐',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

export function BreadcrumbListSchema() {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  const itemListElement = [
    {
      '@type': 'ListItem' as const,
      position: 1,
      name: '首页',
      item: 'https://bukedg.cn/',
    },
  ];

  if (pathParts[0] === 'category' && pathParts[1]) {
    const cat = categories.find((c) => c.slug === pathParts[1]);
    itemListElement.push({
      '@type': 'ListItem' as const,
      position: 2,
      name: cat?.name || pathParts[1],
      item: `https://bukedg.cn/category/${pathParts[1]}`,
    });
  } else if (pathParts[0] === 'article' && pathParts[1]) {
    const article = articles.find((a) => a.id === pathParts[1]);
    itemListElement.push({
      '@type': 'ListItem' as const,
      position: 2,
      name: article?.title || pathParts[1],
      item: `https://bukedg.cn/article/${pathParts[1]}`,
    });
  } else if (pathParts[0] === 'about') {
    itemListElement.push({
      '@type': 'ListItem' as const,
      position: 2,
      name: '关于我们',
      item: 'https://bukedg.cn/about',
    });
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

export function FAQPageSchema() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

interface ArticleSchemaProps {
  title: string;
  description: string;
  datePublished: string;
  imageUrl: string;
  url: string;
  authorName?: string;
}

export function ArticleSchema({ title, description, datePublished, imageUrl, url, authorName }: ArticleSchemaProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    datePublished: datePublished,
    image: imageUrl,
    url: url,
    author: {
      '@type': 'Organization',
      name: authorName || '壹号娱乐',
    },
    publisher: {
      '@type': 'Organization',
      name: '壹号娱乐',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

export function AboutPageSchema() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于壹号娱乐',
    description: `壹号娱乐成立于${aboutInfo.founded}，是值得信赖的综合娱乐平台。${aboutInfo.mission}`,
    about: {
      '@type': 'Organization',
      name: '壹号娱乐',
      foundingDate: '2018',
      description: aboutInfo.mission,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}